import theme from "Theme/AppTheme";

export const defaultColorScheme = [
    theme.palette.green.main,
    theme.palette.blue.main,
    theme.palette.orange.main,
    theme.palette.red.main,
];

export const signalsChartColorScheme = [
    theme.palette.primary[800], // #1D2A60
    theme.palette.primary[500], // #3364D6
    theme.palette.secondary[500], // #32D1B7
    theme.palette.secondary[800], // #239C98
    theme.palette.purple[500], // #7A30CA
    theme.palette.purple[200], // #BD97E5
    theme.palette.primary[300], // #6F95F4
    theme.palette.primary[700], // #1E40AF
    theme.palette.purple[300], // #9C64D7
    theme.palette.purple[700] // #5C2497
];

// [TreeMap Testing] For testing purposes only — remove when drivers is complete.
export const treeMapColorScheme = [
    theme.palette.primary[500], // #3364D6
    theme.palette.secondary[500], // #32D1B7
    theme.palette.purple[500], // #7A30CA
];

export const pieGraphDefaultColorScheme: string[] = [
    theme.palette.green.main,
    theme.palette.blue.main,
    theme.palette.orange.main,
    theme.palette.red.main,
    theme.palette.green.dark!, // need to ensure green dark gets set
    theme.palette.yellow.main,
];

export const Palettes = {
    specialEddyColors: [
        theme.palette.highlight.eddy.main,
        ...signalsChartColorScheme,
    ],
    // Keep current-period on primary[800] and previous-period on eddy blue when comparePrev is enabled
    specialEddyComparePrev: [
        theme.palette.primary[800],
        theme.palette.highlight.eddy.main,
    ],
    signalsChartColorScheme: signalsChartColorScheme,
    defaultColorScheme: defaultColorScheme,
    pieGraphDefaultColorScheme: pieGraphDefaultColorScheme,
    // [TreeMap Testing] For testing purposes only — remove when drivers is complete.
    treeMapColorScheme: treeMapColorScheme,
};
